import { Tab, TabList, TabPanels, Tabs } from "@carbon/react";
import { Outlet } from "react-router-dom";

import PageHeader from "src/components/PageHeader.tsx";
import PageStack from "src/components/PageStack/PageStack.tsx";
import { useTabNavigation } from "src/components/TabbedView/useTabNavigation.ts";
import { useT } from "src/internationalization";
import { useCaseTypes } from "src/providers/CaseTypesProvider";

export default function CasesPage() {
  const t = useT();
  const { caseTypes } = useCaseTypes();

  const tabs = caseTypes.map((caseType) => {
    return { code: caseType.code, label: caseType.name };
  });

  const { navigateTab, selectedTab } = useTabNavigation({
    tabs,
    pathPrefix: "/cases",
    getSearch: (searchParams) => {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete("offset");
      newSearchParams.delete("index");
      return newSearchParams.toString();
    },
  });

  const onTabChange = (state: { selectedIndex: number }) => navigateTab(state.selectedIndex);

  return (
    <PageStack>
      <div className="flex justify-between">
        <PageHeader>{t("page.cases.title")}</PageHeader>
      </div>
      <Tabs selectedIndex={selectedTab?.index ?? 0} onChange={onTabChange}>
        <TabList aria-label="List of tabs">
          {tabs.map((tab) => (
            <Tab key={tab.code}>{tab.label}</Tab>
          ))}
        </TabList>
        <TabPanels>
          <div className="mt-5">
            <Outlet />
          </div>
        </TabPanels>
      </Tabs>
    </PageStack>
  );
}
